import { inject, Injectable } from '@angular/core'
import { combineLatestWith, Observable, of, switchMap, tap } from 'rxjs'
import { PieceJointeHttpService } from '../data-access/http/piece-jointe-http.service'
import { PieceJointeDto } from '../data-access/http/dto/piece-jointe.dto'
import { downloadFile } from '../utils/utils'
import { PieceJointeS3Dto } from '../data-access/http/dto/piece-jointe-s3.dto'
import { PieceJointeUploadDto } from '../data-access/http/dto/piece-jointe-upload.dto'

@Injectable({ providedIn: 'root' })
export class PieceJointeDomainService {
    private readonly pieceJointeHttpService = inject(PieceJointeHttpService)

    uploadToAwsLambda(file: File): Observable<[PieceJointeS3Dto, PieceJointeUploadDto]> {
        return this.pieceJointeHttpService
            .getUploadUrl(file)
            .pipe(
                switchMap((jsonDataUploadResponse) =>
                    this.pieceJointeHttpService
                        .uploadPieceJointeToS3(file, jsonDataUploadResponse)
                        .pipe(combineLatestWith(of(jsonDataUploadResponse))),
                ),
            )
    }

    downloadPieceJointeById(documentId: string): Observable<[Blob, PieceJointeDto]> {
        return this.pieceJointeHttpService.getPhotoById(documentId).pipe(
            switchMap((pieceJointe: PieceJointeDto) =>
                this.pieceJointeHttpService
                    .downloadPieceJointe(pieceJointe.lambdaUrl)
                    .pipe(combineLatestWith(of(pieceJointe))),
            ),
            tap(([blob, pieceJointe]) => downloadFile(blob, pieceJointe.fileName)),
        )
    }
}
